import { render, staticRenderFns } from "./IntranetDashboard.vue?vue&type=template&id=36e9f4a0&"
import script from "./IntranetDashboard.vue?vue&type=script&lang=js&"
export * from "./IntranetDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports